






















































import { Vue, Component, Prop } from "@/shared/vuepack";
import Button from "@/shared/components/ui/Button.vue";
import { HouseholdMember } from "@/shared/types";
import EditFamilyMember from "@/employee/components/contributionPlanner/EditFamilyMember.vue";
import * as _ from "lodash";
import { useThemeStore } from "@/shared/store/theme";

const emptyHouseholdMemberModel: HouseholdMember = {
  familyMemberId: 0,
  memberType: null,
  firstName: "",
  lastName: "",
  birthYear: null,
  sex: "",
  usesTobacco: false,
  conditions: [],
  key: ""
};

@Component({
  components: {
    Button,
    EditFamilyMember
  }
})
export default class FamilyMemberRow extends Vue {
  @Prop()
  member: HouseholdMember; // family member

  @Prop()
  conditions: string[];

  themeStore = useThemeStore();

  editMemberFormVisible = { value: false };
  editMemberModel = { ...emptyHouseholdMemberModel };
  deleteConfirmationVisible = false;

  toggleEdit () {
    this.editMemberModel = _.cloneDeep(this.member);
    this.editMemberFormVisible.value = true;
  }

  toggleClose () {
    this.editMemberFormVisible.value = false;
  }

  onEditClose () {
    _.assign(this.member, this.editMemberModel);
    this.editMemberFormVisible.value = false;
  }

  onDelete () {
    this.deleteConfirmationVisible = true;
  }

  deleteMember (member: any) {
    this.$emit("deleteMember", member);
  }
}
